import { unregister } from 'registerServiceWorker';
import store from 'store';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import AppRoot from 'components/core/AppRoot';
import SomethingWentWrong from './components/core/SomethingWentWrong';
import { ErrorBoundary } from '@sentry/react';

render(
  <ErrorBoundary
    fallback={({ resetError }) => (
      <SomethingWentWrong resetError={resetError} />
    )}
  >
    <Provider store={store}>
      <AppRoot />
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
);

unregister();
